import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './TheSolution.css';

function TheSolution() {
    return (
        <section id='solution'>
            <div className="solution-bg">
                <Container fluid>
                    <Row className='col-op-first'>
                        <Col lg={6}>
                            <div className='col-sol-first-div'>
                                <h1>
                                    The Solution
                                </h1>
                            </div>
                        </Col>
                        <Col lg={6}>
                        </Col>
                    </Row>
                </Container>

                <Container fluid>
                    <Row className='sol-col-op'>
                        <Col lg={4} md={12} sm={12}>
                            <div className='sol-left-div'>
                                <div className="sol-left-img"></div>
                            </div>
                        </Col>
                        <Col lg={8} md={12} sm={12}>
                            <div className='sol-right-txt'>
                                <div>
                                    <h3>
                                        ViaCool provides an <span className='sol-right-txt-span-clr'>accurate prediction of shelf life</span><br />
                                        and quality score for fresh fruits and vegetables.<br />
                                        The team has developed a platform that utilizes<br />
                                        proprietary scientific knowledge, big data and<br />
                                        proprietary algorithms to provide commercial<br />
                                        insights. The outcomes enable the supply chain to<br />
                                        take <span className='sol-right-txt-span-clr'>precise operational and business decisions</span><br />
                                        whilst <span className='sol-right-txt-span-clr'>reducing the amount of food waste.</span>
                                    </h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default TheSolution
